import { Bell } from "lucide-react";
import InfoBanner from "./InfoBanner";

export default function MonitoringTab({
  errorThreshold,
  setErrorThreshold,
  latencyThreshold,
  setLatencyThreshold,
  notificationChannel,
  setNotificationChannel,
  alertTypes,
  setAlertTypes
}) {
  const handleAlertTypeChange = (type) => {
    setAlertTypes({
      ...alertTypes,
      [type]: !alertTypes[type]
    });
  };

  return (
    <div className="space-y-6">
      {/* Alert Configuration */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Alert Configuration
        </h3>
        <InfoBanner
          icon={Bell}
          title="Real-time Monitoring"
          description="Get notified when issues occur or thresholds are exceeded."
        />
      </div>

      {/* Error Threshold */}
      <div>
        <label className="block text-sm font-medium text-gray-900 mb-2">
          Error Threshold
        </label>
        <div className="relative">
          <input
            type="number"
            value={errorThreshold}
            onChange={(e) => setErrorThreshold(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-500">
            errors per minute
          </span>
        </div>
      </div>

      {/* Latency Threshold */}
      <div>
        <label className="block text-sm font-medium text-gray-900 mb-2">
          Latency Threshold
        </label>
        <div className="relative">
          <input
            type="number"
            value={latencyThreshold}
            onChange={(e) => setLatencyThreshold(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-500">
            milliseconds
          </span>
        </div>
      </div>

      {/* Notification Channel */}
      <div>
        <label className="block text-sm font-medium text-gray-900 mb-2">
          Notification Channel
        </label>
        <select
          value={notificationChannel}
          onChange={(e) => setNotificationChannel(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
        >
          <option value="email">Email</option>
          <option value="slack">Slack</option>
          <option value="webhook">Webhook</option>
          <option value="sms">SMS</option>
        </select>
      </div>

      {/* Alert Types */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Alert Types
        </h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">Connection failures</span>
            <input
              type="checkbox"
              checked={alertTypes.connectionFailures}
              onChange={() => handleAlertTypeChange("connectionFailures")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">Rate limit warnings</span>
            <input
              type="checkbox"
              checked={alertTypes.rateLimitWarnings}
              onChange={() => handleAlertTypeChange("rateLimitWarnings")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">High latency alerts</span>
            <input
              type="checkbox"
              checked={alertTypes.highLatencyAlerts}
              onChange={() => handleAlertTypeChange("highLatencyAlerts")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">Authentication errors</span>
            <input
              type="checkbox"
              checked={alertTypes.authenticationErrors}
              onChange={() => handleAlertTypeChange("authenticationErrors")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">
              Data validation errors
            </span>
            <input
              type="checkbox"
              checked={alertTypes.dataValidationErrors}
              onChange={() => handleAlertTypeChange("dataValidationErrors")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-900">Weekly usage summary</span>
            <input
              type="checkbox"
              checked={alertTypes.weeklyUsageSummary}
              onChange={() => handleAlertTypeChange("weeklyUsageSummary")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
